import { styled } from 'styled-components';

import { EmployerDetails, EmployerDetailsProps } from './EmployerDetails';
import { spacing } from '../../../styles/spacing';
import { Headings } from '../../Headings';
import { Flex } from '../../Layout';
import { useIsDeviceSize } from '../../Media';
import { bannerStyle } from '../common/commonStyles';
import { theme } from '../../../styles';

const Banner = styled.header`
  ${bannerStyle}
  justify-content: center;
  background-color: ${theme.colors.darkBlue};

  @media (max-width: ${spacing.breakpoint.lg - 1}px) {
    padding: 10px 40px;
  }
`;

type OrganizationDetails = Omit<EmployerDetailsProps, 'detailRows'>;

type EmployerBannerProps = {
  orgDetails?: OrganizationDetails;
  title: string;
};

export const EmployerBanner = ({ title, orgDetails }: EmployerBannerProps) => {
  const { isMobile, isTablet } = useIsDeviceSize();

  return (
    <Banner>
      <Flex
        width="100%"
        maxWidth={1196}
        justifyContent="space-between"
        alignItems="center"
        flexDirection={['column', 'column', 'row']}
        columnGap={10}
        rowGap={20}
      >
        <Headings.H1 color="white">{title}</Headings.H1>
        {orgDetails && <EmployerDetails {...orgDetails} detailRows={isMobile ? 2 : isTablet ? 1 : 3} />}
      </Flex>
    </Banner>
  );
};
